import React from 'react';
import styles from './Icons.scss';
import cn from 'classnames';
import { IconProps, Icons } from './IconsRes';
import { getIconClasses } from '@/Static/IconUtils';

export function RefDocsIcon({ id, size = 'small', onClick, disabled, className }: IconProps) {
  return (
    <img
      id={id}
      src={Icons.RefDocs}
      alt="img"
      className={cn(styles.icon, getIconClasses(size, disabled), className)}
      onClick={() => {
        if (!disabled) onClick?.();
      }}
    />
  );
}
